import { createSlice } from '@reduxjs/toolkit'

export const mainSubmenuSlice = createSlice({
    name: 'mainSubmenu',
    initialState: {
        submenu1Slug: '',
        submenu2Slug: '',
    },
    reducers: {
        setSubmenu1Slug: (state, action) => {
            state.submenu1Slug = action.payload;
            if (state.submenu1Slug == '') {
                state.submenu2Slug = ''
            }
        },
        setSubmenu2Slug: (state, action) => {
            state.submenu2Slug = action.payload
        },
    }
})

export const { setSubmenu1Slug, setSubmenu2Slug } = mainSubmenuSlice.actions
export default mainSubmenuSlice.reducer
